import React, { useEffect } from 'react';
import BackupConfigurationForm from './BackupConfigurationForm';
import BackupHistoryTable from './BackupHistoryTable';
import { useBackup } from '../../../hooks/settings/useBackup';

const BackupSettingsPanel: React.FC = () => {
  const { fetchConfiguration, fetchHistory, pageSize } = useBackup();

  useEffect(() => {
    fetchConfiguration();
    fetchHistory(0, pageSize);
  }, []);

  return (
    <div className="space-y-10 p-4 sm:p-6">
      <BackupConfigurationForm />
      <BackupHistoryTable />
    </div>
  );
};

export default BackupSettingsPanel;
